<template>
  <div class="fy-step">
    <!-- 法援step -->
    <div v-for="(item,index) in steplist" :key="'key-'+index" :style="'width:'+stepitemwidth" class="item" :class="[(index!=0)?'centers': '',((index+1)==type)?'active':'']">
      {{ item }}
      <div v-if="index!==steplistlength" class="sanjiao" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'step',
  props: {
    type: {
      type: Number, // 第几步
      default: 1
    },
    steplist: {
      type: Array,
      default: () => { return [] }
    },
    stepitemwidth: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      steplistlength: 0
    }
  },
  mounted () {
    this.steplistlength = this.steplist.length - 1
  }
}
</script>

<style lang="stylus" scoped>
.fy-step {
  width: 12rem;
  margin: 0 auto;
  display: flex;

  .item {
    position: relative;
    width: 3.94rem;
    height: 0.68rem;
    line-height: 0.68rem;
    text-align: center;
    font-size: 0.3rem;
    position: relative;
    background: rgba(255, 255, 255, 0.2);
    margin-left: 0.4rem;
    color: #fff;

    .sanjiao {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 0.34rem;
      display: block;

      &:before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        top: 0;
        left: 0.34rem;
        border-style: solid;
        z-index: 10;
        border-width: 0.34rem 0 0.34rem 0.34rem;
        border-color: transparent transparent transparent rgba(255, 255, 255, 0.2);
      }
    }

    &:before, &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
    }

    &:first-child {
      border-radius: 0.08rem 0px 0px 0.08rem;
      margin-left: 0;
    }

    &.centers {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        border-style: solid;
        left: -0.34rem;
        z-index: 10;
        border-width: 0 0.34rem 0.34rem 0;
        border-color: transparent rgba(255, 255, 255, 0.2) transparent transparent;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        border-style: solid;
        left: -0.34rem;
        z-index: 10;
        border-width: 0 0 0.34rem 0.34rem;
        border-color: transparent transparent rgba(255, 255, 255, 0.2) transparent;
      }
    }

    &:last-child {
      border-radius: 0px 0.08rem 0.08rem 0px;
    }

    &.active {
      background: #fc9d0b;
      color: #fff;

      .sanjiao {
        &:before {
          border-color: transparent transparent transparent #fc9d0b;
        }
      }

      &.centers {
        &:before {
          border-color: transparent #fc9d0b transparent transparent;
        }

        &:after {
          border-color: transparent transparent #fc9d0b transparent;
        }
      }
    }
  }
}
</style>
